import  { Fragment, useState } from "react";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button
} from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";
import { BondModal } from "../../Components/bond/BondModal";

export const BondList = () => {
  const { getData, patchData } = useDataFetch();
  const { data, isLoading } = getData(["bonds"], "/bonds", { enabled: true });


  const { mutateAsync: updateLevel } = patchData("/bonds", {}, {
    onSuccess: (response) => {
      if (response.message == "update_porcentage_success") {
        toast.success("Porcentaje actualizado correctamente");
      }
    },
  });

  const [selectedBond, setSelectedBond] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [levels, setLevels] = useState([]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleOpenModal = (bond) => {
    setSelectedBond(bond);
    setLevels(bond.levels || []);
    setIsModalOpen(true);
  };

  const handleLevelChange = (index, value) => {
    const updated = [...levels];
    updated[index].porcentage = Number(value);
    setLevels(updated);
  };

  const handleUpdateLevel = async (level) => {
    try {
      const payload = {
        idBond: selectedBond.id,
        idLevel: level.id,
        porcentage: level.porcentage,
      };


      await updateLevel(payload);
    } catch (error) {
      console.error("Error al actualizar nivel:", error);
      toast.error("Error al actualizar nivel");
    }
  };

  if (isLoading) return <p>Cargando...</p>;

  return (
    <Fragment>
      <Breadcrumbs parent="Red" title="Bonos" mainTitle="Bonos" />
      <Container fluid={true}>
        <Row className="justify-content-center mt-4">
          {data?.data?.bonds.map((item, index) => (
            <Col md="4" key={index}>
              <Card>
                <div className="job-search">
                  <CardBody>
                    <div className="media">
                      <div className="media-body">
                        <h6 className="text-center f-800">{item.name}</h6>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center mt-3">
                      <Button color="primary" onClick={() => handleOpenModal(item)}>
                        Configurar niveles
                      </Button>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* ✅ Modal de configuración por nivel */}
       <BondModal
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        selectedBond={selectedBond}
        levels={levels}
        handleLevelChange={handleLevelChange}
        handleUpdateLevel={handleUpdateLevel}
      />
    </Fragment>
  );
};
